module.exports = require("./dist/Closest");



/*****************
 ** WEBPACK FOOTER
 ** ./~/@aneves/js-closest/index.js
 ** module id = 101
 ** module chunks = 0
 **/